import GenerateType from './GenerateType';
import ImportProfile from './ImportProfile';
import TypeDetail from './TypeDetail';
import TypePropertyDetail from './TypePropertyDetail';
import TypesList from './TypesList';
import { useTypes } from './TypesProvider';

const Types = () => {
    const { TYPE_SCREENS, currentScreen } = useTypes();

    const getScreen = () => {
        switch (currentScreen) {
            case TYPE_SCREENS.typeList:
                return <TypesList />;
            case TYPE_SCREENS.typeDetail:
                return <TypeDetail />;
            case TYPE_SCREENS.typePropertyDetail:
                return <TypePropertyDetail />;
            case TYPE_SCREENS.importProfile:
                return <ImportProfile />;
            case TYPE_SCREENS.typeGenerate:
                return <GenerateType />;
            default:
                return <TypesList />;
        }
    };

    return <div className="page-wrapper">{getScreen()}</div>;
};

export default Types;
